export default __webpack_public_path__ + "static/media/doc-thank.8146bf21.svg";